import { type StorageAdapter } from "../store-contract";
import { createBundleStore } from "./bundle";
import { createCatalogStore } from "./catalog";
import { createDraftStore } from "./drafts";
import { createEvidenceStore } from "./evidence";
import { createLifecycleStore } from "./lifecycle";
import { createOutboxStore } from "./outbox";

/**
 * The whole browser storage adapter: the six group factories spread into one
 * object, and the only place `StorageAdapter` is named as a return type. The
 * spread is the completeness mechanism's other half — `tsc` proves every
 * contract member exists with the right signature because the intersection
 * type admits nothing partial, and the shared contract suite proves each one
 * behaves like its device-store counterpart.
 */
export function createIndexedDbStorage(db: IDBDatabase): StorageAdapter {
  return {
    ...createBundleStore(db),
    ...createDraftStore(db),
    ...createOutboxStore(db),
    ...createEvidenceStore(db),
    ...createLifecycleStore(db),
    ...createCatalogStore(db),
  };
}
